import { toBase64 } from '../../../../utils/utf8.js';
import { ExecArgBase, dataToExecData } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecArgNeptuneWithdraw extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgNeptuneWithdraw(params);
    }
    toData() {
        const { params } = this;
        const innerMsg = { redeem: {} };
        const encodedMsg = toBase64(innerMsg);
        return {
            amount: params.amount,
            contract: params.contract,
            msg: encodedMsg,
        };
    }
    toExecData() {
        return dataToExecData('send', this.toData());
    }
}
